import React, { useState, useEffect } from 'react';
import PageHeader from '../../PageHeader/PageHeader';
import AppInput from '../../components/AppInput/AppInput';
import { useSelector, useDispatch } from 'react-redux';
import TextArea from '../../components/AppInput/TextArea';
import { setApiErrorJson, setApiJson } from '../../redux/Actions/ApiAction';
import AppButton from '../../components/AppButton/AppButton';
import { HitApi } from '../../Api/ApiHit';
import { Calendar, User, DollarSign, Clock, Shield, UserCheck, Key } from 'lucide-react';
import AppSelect from '../../components/AppSelect/AppSelect';
import { StaffValidation } from '../../validationscheema/StaffValidation';
import { addStaff, searchStaff, updateStaff } from '../../constant/Constant';
import { genderOptions, statusOptions, typeOptions } from '../../constant/Options';
import { EMAIL_REGEX, REGXEMAIL } from '../../constant/regex';
import { getSelectedUnit } from '../../storage/Storage';
import FileuploadComp from '../../components/SingleFileUpload/FileuploadComp';

function AddStaff() {
  const ApiReducer = useSelector((state) => state.ApiReducer);
  const dispatch = useDispatch();

  const [isEditMode, setIsEditMode] = useState(false);

  const url = window.location.pathname;
  const urlId = url.split('/')[3];

  useEffect(() => {
    const initialStaffData = {
      name: "",
      email: "",
      address: "",
      contact: "",
      dob: "",
      doj: "",
      gender: "Male",
      type: "Employee",
      code: "STAF" + Math.floor(10000 + Math.random() * 90000),
      img: "",
      salary: "",
      workHourPerDay: "9",



      designation: ''
    };

    if (urlId) {
      setIsEditMode(true);
      loadData();
    } else {
      dispatch(setApiJson(initialStaffData));
      dispatch(setApiErrorJson({}));
    }
  }, [dispatch, urlId]);



  console.log("ApiReducer", ApiReducer);


  const handleSubmit = () => {
    StaffValidation(ApiReducer?.apiJson).then((errors) => {
      dispatch(setApiErrorJson(errors));

      if (Object.keys(errors).length === 0) {
        const staffData = { ...ApiReducer.apiJson, unitIds: getSelectedUnit()?._id };

        if (isEditMode) {
          HitApi(staffData, updateStaff).then((res) => {
            console.log("Update response:", res);
            if (res?.message === "Staff updated successfully") {
              window.location.pathname = '/staff'
            }
          });
        } else {
          HitApi(staffData, addStaff).then((res) => {
            console.log("Create response:", res);
            if (res?.message === "Staff created successfully") {
              window.location.pathname = '/staff'
            }
            else {
              alert(res?.message)
            }

          });
        }
      }
    });
  };



  const loadData = () => {
    var json = {
      page: 1,
      limit: 10,
      search: {
        _id: urlId,
        unitIds: getSelectedUnit()?._id
      }
    };

    HitApi(json, searchStaff).then((res) => {
      console.log("result", res);
      if (res?.message === "Staff retrieved successfully") {
        const staffData = res?.data?.[0];

        if (staffData) {
          // Format dates if needed
          if (staffData.dob) {
            staffData.dob = staffData.dob.split(' ')[0]; // Get only the date part
          }
          if (staffData.doj) {
            staffData.doj = staffData.doj.split(' ')[0]; // Get only the date part
          }

          dispatch(setApiJson(staffData));
        }
      }
    });
  };

  return (
    <div className="p-5">
      <PageHeader
        title={isEditMode ? 'Edit Staff' : 'Add New Staff'}
        description={isEditMode ? 'Update Staff Information' : 'Add New Staff Member'}
      />

      <div className="bg-white p-8 border rounded-xl mb-6">
        <div className="text-lg font-medium mb-5 flex justify-between items-center">
          <span>Personal Information</span>
          <AppButton
            buttontext={isEditMode ? "Update Staff" : "Add Staff"}
            onClick={handleSubmit}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          <AppInput
            title="Full Name"
            placeholder="Enter full name"
            name="name"
            important={true}
            error={!ApiReducer?.apiJson?.name}
            icon={<User size={18} />}
          />

          <AppInput
            title="Email"
            placeholder="Enter email address"
            name="email"
            important={true}
            error={!EMAIL_REGEX.test(ApiReducer?.apiJson?.email)}
            type="email"
          />
          <AppInput
            title="Contact Number"
            placeholder="Enter contact number"
            name="contact"
            important={true}
            error={ApiReducer?.apiJson?.contact?.length !== 10}
          />
          <AppInput
            title="Designation"
            placeholder="Enter designation"
            name="designation"
            important={true}
            error={!ApiReducer?.apiJson?.designation}
          />
          <AppInput
            title="Staff Code"
            placeholder="Auto-generated"
            name="code"
          />
          <AppInput
            title="Date of Birth"
            placeholder="YYYY-MM-DD"
            name="dob"
            type="date"
          />
          <AppInput
            title="Date of Joining"
            placeholder="YYYY-MM-DD"
            name="doj"
            type="date"
            icon={<Calendar size={18} />}
          />
          <AppSelect
            title="Gender"
            name="gender"
            options={genderOptions}
          />
          <AppSelect
            title="Staff Type"
            name="type"
            options={typeOptions}
            icon={<UserCheck size={18} />}
          />

        </div>
       <div className='mb-5'>
         <FileuploadComp title="Profile Image URL" name="img" allowed={["img"]} />
       </div>

        <TextArea
          title="Address"
          name="address"
          placeholder="Enter staff address..."
          rows={3}
        />
      </div>

      <div className="bg-white p-8 border rounded-xl mb-6">
        <div className="text-lg font-medium mb-5">
          <span>Work Settings</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
          <AppInput
            title="Salary"
            placeholder="Enter salary amount"
            name="salary"
            icon={<DollarSign size={18} />}
          />

          <AppInput
            title="Working Hours Per Day"
            placeholder="9"
            name="workHourPerDay"
            icon={<Clock size={18} />}
          />
          <AppSelect
            title="Status"
            name="status"
            options={statusOptions}
          />
        </div>
      </div>
    </div>
  );
}

export default AddStaff;